import React from "react";

interface Service {
  health: string;
}

interface PlatformHealthData {
  Service: Service[];
}

interface ServicesHealthSummaryProps {
  platformHealth?: PlatformHealthData;
}

export default function ServicesHealthSummary({
  platformHealth,
}: ServicesHealthSummaryProps) {
  const countServices = (predicate: (health: string) => boolean) => {
    return (
      platformHealth?.Service?.filter((service) => predicate(service.health))
        .length || 0
    );
  };

  return (
    <div className="mr-0 md:mr-12 flex flex-col items-center mt-8 md:mt-0">
      <h4 className="mb-4">Services Health Summary</h4>
      <div className="flex flex-row content-center items-center justify-center gap-12">
        {/* GOOD */}
        <div className="flex flex-col items-center">
          <div className="w-[60px] h-[60px] rounded-full flex items-center justify-center bg-green-500 text-white font-bold text-lg mb-1">
            {countServices((health) => health === "GOOD")}
          </div>
          <p className="text-sm font-medium text-gray-700">GOOD</p>
        </div>

        {/* WARNING */}
        <div className="flex flex-col items-center">
          <div className="w-[60px] h-[60px] rounded-full flex items-center justify-center bg-orange-500 text-white font-bold text-lg mb-1">
            {countServices(
              (health) => health === "WARNING" || health === "IMPROVABLE"
            )}
          </div>
          <p className="text-sm font-medium text-gray-700">WARNING</p>
        </div>

        {/* POOR */}
        <div className="flex flex-col items-center">
          <div className="w-[60px] h-[60px] rounded-full flex items-center justify-center bg-red-500 text-white font-bold text-lg mb-1">
            {countServices((health) => health === "BAD" || health === "POOR")}
          </div>
          <p className="text-sm font-medium text-gray-700">POOR</p>
        </div>
      </div>
    </div>
  );
}
